export interface FloatingWindowOffset {
  x: number
  y: number
}

interface Edges {
  left: number
  right: number
  top: number
  bottom: number
}

function clampShift(shift: number, min: number, max: number): number {
  return Math.max(Math.min(shift, max), min)
}

/**
 * Moves a floating window toward `candidate` without letting it leave
 * `containerRect`; a window larger than the container keeps its top-left
 * corner, and so its header, in view.
 */
export function clampFloatingWindowOffset({
  candidate,
  containerRect,
  current,
  windowRect,
}: {
  candidate: FloatingWindowOffset
  containerRect: Edges
  current: FloatingWindowOffset
  windowRect: Edges
}): FloatingWindowOffset {
  return {
    x:
      current.x +
      clampShift(
        candidate.x - current.x,
        containerRect.left - windowRect.left,
        containerRect.right - windowRect.right
      ),
    y:
      current.y +
      clampShift(
        candidate.y - current.y,
        containerRect.top - windowRect.top,
        containerRect.bottom - windowRect.bottom
      ),
  }
}
